import { z } from 'zod';

import { Resistance } from './Resistance';

export const DC_GROUND_REFERENCED_POLES = ['L+', 'L-'] as const;

export type DcGroundReferencedPole = (typeof DC_GROUND_REFERENCED_POLES)[number];

const reference = z
    .object({
        referenced: z.boolean().default(false),
        impedance: Resistance.validators.value,
    })
    .default({});

const validator = z
    .object({
        'L+': reference,
        'L-': reference,
    })
    .default({});

const GroundReferences = {
    validator,
};

export { GroundReferences };

export type GroundReferences = z.infer<typeof validator>;
